// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__18SEh","amount":"Amount_amount__3f3Wz","tip":"Amount_tip__mIbAO","tipHeader":"Amount_tipHeader__1khpE","tipsWrap":"Amount_tipsWrap__2TpJm"};